<template>
    <div class="vehiculos-page personal-admin">
        <a-alert v-if="errorCarga" type="error" show-icon class="mb-3" :message="errorCarga">
            <template slot="description"><a-button :loading="cargando" @click="cargar">Reintentar carga</a-button></template>
        </a-alert>
        <a-card ref="formulario" :bordered="false" class="header-solid vehiculos-card vehiculos-registro">
            <template slot="title">
                <div class="personal-cabecera"><h3>{{ editandoId ? 'Editar vehículo' : 'Registrar vehículo' }}</h3></div>
            </template>
            <a-alert v-if="errorFormulario" type="error" show-icon :message="errorFormulario" class="mb-3" />
            <a-form class="vehiculos-form" layout="vertical" @submit.prevent="guardar">
                <div class="row">
                    <div class="col-md-6">
                        <a-form-item label="Líder" required>
                            <a-select v-model="form.lidere_id" show-search :filter-option="filtrarLider"
                                placeholder="Buscar líder por nombre o apellido" :loading="cargando" :disabled="bloqueado"
                                :not-found-content="cargando ? 'Cargando líderes…' : 'No se encontraron líderes'" aria-label="Líder">
                                <a-select-option v-for="lider in lideres" :key="String(lider.id)" :value="String(lider.id)" :title="nombreLider(lider)">
                                    {{ nombreLider(lider) }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </div>
                    <div class="col-md-6">
                        <a-form-item label="Tipo de vehículo" required>
                            <a-select v-model="form.tipo_vehiculo" placeholder="Seleccionar tipo" :disabled="bloqueado" aria-label="Tipo de vehículo">
                                <a-select-option value="Carro">Carro</a-select-option>
                                <a-select-option value="Motocicleta">Motocicleta</a-select-option>
                            </a-select>
                        </a-form-item>
                    </div>
                    <div class="col-md-6">
                        <a-form-item label="Nombre del conductor" html-for="vehiculo-conductor">
                            <a-input id="vehiculo-conductor" v-model="form.nombre_conductor" :max-length="255" :disabled="bloqueado" />
                        </a-form-item>
                    </div>
                    <div class="col-md-6">
                        <a-form-item label="Número de tarjeta de propiedad" html-for="vehiculo-tarjeta">
                            <a-input id="vehiculo-tarjeta" v-model="form.numero_tarjeta_propiedad" :max-length="255" :disabled="bloqueado" />
                        </a-form-item>
                    </div>
                </div>
                <div class="vehiculos-acciones">
                    <a-button type="primary" html-type="submit" :loading="guardando" :disabled="bloqueado || !lideres.length">
                        {{ editandoId ? 'Guardar cambios' : 'Registrar vehículo' }}
                    </a-button>
                    <a-button v-if="editandoId" :disabled="guardando" @click="limpiarFormulario">Cancelar edición</a-button>
                </div>
                <p v-if="!cargando && !errorCarga && !lideres.length" class="vehiculos-aviso">No hay líderes disponibles para este candidato.</p>
            </a-form>
        </a-card>
        <a-card :bordered="false" class="header-solid vehiculos-card">
            <template slot="title"><div class="personal-cabecera"><h3>Vehículos por líder</h3></div></template>
            <div class="vehiculos-herramientas">
                <a-input-search v-model="busqueda" placeholder="Buscar líder" aria-label="Buscar líder en la tabla" allow-clear />
                <a-button icon="reload" :loading="cargando" :disabled="guardando || !!eliminandoId" @click="cargar">Actualizar</a-button>
            </div>
            <a-table :columns="columnas" :data-source="resumenFiltrado" row-key="id" :loading="cargando"
                :pagination="{ pageSize: 10, hideOnSinglePage: true }" :scroll="{ x: 650 }" :locale="{ emptyText: 'No hay líderes para mostrar' }">
                <template slot="acciones" slot-scope="text, lider">
                    <a-button size="small" :disabled="bloqueado" @click="verDetalle(lider)">Ver detalle</a-button>
                </template>
            </a-table>
        </a-card>
        <a-modal wrap-class-name="vehiculos-detalle" :visible="detalleVisible" :title="'Vehículos de ' + (liderDetalle ? liderDetalle.nombre : '')" :footer="null" :width="960" @cancel="cerrarDetalle">
            <a-alert v-if="errorDetalle" type="error" show-icon :message="errorDetalle" class="mb-3">
                <template slot="description"><a-button :loading="cargandoDetalle" @click="verDetalle(liderDetalle)">Reintentar</a-button></template>
            </a-alert>
            <div class="vehiculos-herramientas">
                <a-input-search v-model="busquedaDetalle" placeholder="Buscar por conductor o tarjeta de propiedad"
                    aria-label="Buscar por conductor o tarjeta de propiedad" allow-clear :disabled="cargandoDetalle" />
            </div>
            <a-table :columns="columnasDetalle" :data-source="detalleFiltrado" row-key="id" :loading="cargandoDetalle"
                :pagination="{ pageSize: 5, hideOnSinglePage: true }" :scroll="{ x: 720 }" :locale="{ emptyText: busquedaDetalle.trim() ? 'No se encontraron vehículos para esta búsqueda' : 'Este líder no tiene vehículos registrados' }">
                <template slot="dato" slot-scope="text">{{ text || 'Sin registrar' }}</template>
                <template slot="acciones" slot-scope="text, vehiculo">
                    <div class="vehiculos-acciones">
                        <a-button size="small" :disabled="cargandoDetalle || !!eliminandoId" @click="editar(vehiculo)">Editar</a-button>
                        <a-popconfirm title="¿Eliminar este vehículo? Esta acción no se puede deshacer." ok-text="Eliminar" cancel-text="Cancelar"
                            :disabled="cargandoDetalle || !!eliminandoId" @confirm="eliminar(vehiculo)">
                            <a-button size="small" type="danger" :loading="eliminandoId === vehiculo.id" :disabled="cargandoDetalle || !!eliminandoId">Eliminar</a-button>
                        </a-popconfirm>
                    </div>
                </template>
            </a-table>
        </a-modal>
    </div>
</template>

<script>
import axios from 'axios';

const formularioVacio = () => ({ lidere_id: undefined, tipo_vehiculo: undefined, nombre_conductor: '', numero_tarjeta_propiedad: '' });
const normalizar = valor => String(valor || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

export default {
    name: 'Vehiculos',
    data() {
        return {
            lideres: [], vehiculos: [], form: formularioVacio(), editandoId: null,
            cargando: false, guardando: false, eliminandoId: null,
            errorCarga: '', errorFormulario: '', errorDetalle: '', busqueda: '', busquedaDetalle: '',
            detalleVisible: false, liderDetalle: null, detalle: [], cargandoDetalle: false, solicitudDetalle: 0, solicitudCarga: 0,
            columnas: [
                { title: 'Líder', dataIndex: 'nombre', key: 'nombre' },
                { title: 'Total vehículos', dataIndex: 'total', key: 'total' },
                { title: 'Carros', dataIndex: 'carros', key: 'carros' },
                { title: 'Motocicletas', dataIndex: 'motos', key: 'motos' },
                { title: 'Acciones', key: 'acciones', scopedSlots: { customRender: 'acciones' } }
            ],
            columnasDetalle: [
                { title: 'Tipo', dataIndex: 'tipo_vehiculo', key: 'tipo' },
                { title: 'Conductor', dataIndex: 'nombre_conductor', key: 'conductor', scopedSlots: { customRender: 'dato' } },
                { title: 'Tarjeta de propiedad', dataIndex: 'numero_tarjeta_propiedad', key: 'tarjeta', scopedSlots: { customRender: 'dato' } },
                { title: 'Acciones', key: 'acciones', scopedSlots: { customRender: 'acciones' } }
            ]
        };
    },
    computed: {
        detalleFiltrado() {
            const busqueda = normalizar(this.busquedaDetalle.trim());
            return this.detalle.filter(vehiculo =>
                normalizar(vehiculo.nombre_conductor).includes(busqueda) ||
                normalizar(vehiculo.numero_tarjeta_propiedad).includes(busqueda)
            );
        },
        candidatoId() { return this.$store.state.user && this.$store.state.user.candidato_id; },
        bloqueado() { return this.cargando || this.guardando || !!this.errorCarga; },
        resumenFiltrado() {
            const conteos = {};
            this.vehiculos.forEach(vehiculo => {
                const id = String(vehiculo.lidere_id);
                if (!conteos[id]) conteos[id] = { total: 0, carros: 0, motos: 0 };
                conteos[id].total++;
                if (vehiculo.tipo_vehiculo === 'Carro') conteos[id].carros++;
                if (vehiculo.tipo_vehiculo === 'Motocicleta') conteos[id].motos++;
            });
            return this.lideres.map(lider => ({
                id: String(lider.id), nombre: this.nombreLider(lider),
                ...(conteos[String(lider.id)] || { total: 0, carros: 0, motos: 0 })
            })).filter(lider => normalizar(lider.nombre).includes(normalizar(this.busqueda)));
        }
    },
    watch: {
        candidatoId() {
            this.cerrarDetalle();
            this.limpiarFormulario();
            this.lideres = [];
            this.vehiculos = [];
            this.cargar();
        }
    },
    created() { this.cargar(); },
    beforeDestroy() { this.solicitudDetalle++; this.solicitudCarga++; },
    methods: {
        configPeticion() { return { headers: { Authorization: `Bearer ${this.$store.state.user.token}` } }; },
        nombreLider(lider) { return [lider.nombres, lider.apellidos].filter(Boolean).join(' ') || `Líder #${lider.id}`; },
        filtrarLider(valor, opcion) { return normalizar(opcion.componentOptions.propsData.title).includes(normalizar(valor)); },
        mensajeError(error, defecto) {
            const datos = error.response && error.response.data;
            if (datos && datos.errors) return Object.values(datos.errors).flat().join(' ');
            return (datos && datos.message) || defecto;
        },
        async cargar() {
            const solicitud = ++this.solicitudCarga;
            const candidato = this.candidatoId;
            this.errorCarga = '';
            this.cargando = false;
            if (!candidato) {
                this.errorCarga = 'No se pudo identificar el candidato activo para cargar sus líderes.';
                return;
            }
            this.cargando = true;
            try {
                const [lideres, vehiculos] = await Promise.all([
                    axios.get(`api/lideres/${candidato}`, this.configPeticion()),
                    axios.get('api/vehiculos', this.configPeticion())
                ]);
                if (solicitud !== this.solicitudCarga) return;
                if (!Array.isArray(lideres.data.lideres) || !Array.isArray(vehiculos.data.vehiculos)) throw new Error('Respuesta inesperada');
                this.lideres = lideres.data.lideres;
                const ids = new Set(this.lideres.map(lider => String(lider.id)));
                this.vehiculos = vehiculos.data.vehiculos.filter(vehiculo => ids.has(String(vehiculo.lidere_id)));
            } catch (error) {
                if (solicitud === this.solicitudCarga) this.errorCarga = this.mensajeError(error, 'No se pudieron cargar los líderes y vehículos. Intenta nuevamente.');
            } finally {
                if (solicitud === this.solicitudCarga) this.cargando = false;
            }
        },
        limpiarFormulario() {
            this.form = formularioVacio();
            this.editandoId = null;
            this.errorFormulario = '';
        },
        async guardar() {
            if (this.bloqueado) return;
            this.errorFormulario = '';
            if (!this.lideres.some(lider => String(lider.id) === this.form.lidere_id) || !['Carro', 'Motocicleta'].includes(this.form.tipo_vehiculo)) {
                this.errorFormulario = 'Selecciona un líder y el tipo de vehículo.';
                return;
            }
            this.guardando = true;
            const editando = this.editandoId;
            const datos = {
                ...this.form, lidere_id: Number(this.form.lidere_id),
                nombre_conductor: this.form.nombre_conductor.trim() || null,
                numero_tarjeta_propiedad: this.form.numero_tarjeta_propiedad.trim() || null
            };
            try {
                if (editando) await axios.put(`api/vehiculos/${editando}`, datos, this.configPeticion());
                else await axios.post('api/vehiculos', datos, this.configPeticion());
                this.limpiarFormulario();
                this.$message.success(editando ? 'Vehículo actualizado correctamente.' : 'Vehículo registrado correctamente.');
                await this.cargar();
            } catch (error) {
                this.errorFormulario = this.mensajeError(error, 'No se pudo guardar el vehículo. Intenta nuevamente.');
            } finally { this.guardando = false; }
        },
        async verDetalle(lider) {
            const solicitud = ++this.solicitudDetalle;
            this.liderDetalle = lider;
            this.detalleVisible = true;
            this.busquedaDetalle = '';
            this.detalle = [];
            this.errorDetalle = '';
            this.cargandoDetalle = true;
            try {
                const respuesta = await axios.get(`api/vehiculos-lider/${lider.id}`, this.configPeticion());
                if (solicitud !== this.solicitudDetalle) return;
                if (!Array.isArray(respuesta.data.vehiculos)) throw new Error('Respuesta inesperada');
                this.detalle = respuesta.data.vehiculos.filter(vehiculo => String(vehiculo.lidere_id) === String(lider.id));
                this.vehiculos = this.vehiculos.filter(vehiculo => String(vehiculo.lidere_id) !== String(lider.id)).concat(this.detalle);
            } catch (error) {
                if (solicitud === this.solicitudDetalle) this.errorDetalle = this.mensajeError(error, 'No se pudo cargar el detalle de vehículos.');
            } finally {
                if (solicitud === this.solicitudDetalle) this.cargandoDetalle = false;
            }
        },
        cerrarDetalle() { this.detalleVisible = false; this.solicitudDetalle++; this.cargandoDetalle = false; },
        editar(vehiculo) {
            this.editandoId = vehiculo.id;
            this.form = {
                lidere_id: String(vehiculo.lidere_id), tipo_vehiculo: vehiculo.tipo_vehiculo,
                nombre_conductor: vehiculo.nombre_conductor || '', numero_tarjeta_propiedad: vehiculo.numero_tarjeta_propiedad || ''
            };
            this.errorFormulario = '';
            this.cerrarDetalle();
            this.$nextTick(() => this.$refs.formulario.$el.scrollIntoView({ behavior: 'smooth', block: 'start' }));
        },
        async eliminar(vehiculo) {
            if (this.eliminandoId) return;
            this.eliminandoId = vehiculo.id;
            try {
                await axios.delete(`api/vehiculos/${vehiculo.id}`, this.configPeticion());
                this.detalle = this.detalle.filter(item => item.id !== vehiculo.id);
                this.vehiculos = this.vehiculos.filter(item => item.id !== vehiculo.id);
                if (this.editandoId === vehiculo.id) this.limpiarFormulario();
                this.$message.success('Vehículo eliminado correctamente.');
            } catch (error) {
                this.$message.error(this.mensajeError(error, 'No se pudo eliminar el vehículo. Intenta nuevamente.'));
            } finally { this.eliminandoId = null; }
        }
    }
};
</script>

<style scoped src="../assets/styles/personal-admin.css"></style>
<style>
/* Limitados a Vehículos; el modal se renderiza fuera de la página. */
.vehiculos-page { padding-top: 16px; }
.vehiculos-page .vehiculos-registro { margin-bottom: 20px; }
.vehiculos-page .vehiculos-card .ant-card-head { padding: 16px 16px 0; min-height: 0; }
.vehiculos-page .vehiculos-card .ant-card-head-wrapper { min-height: 0; }
.vehiculos-page .vehiculos-card .ant-card-head-title { padding: 0; }
.vehiculos-page .personal-cabecera { padding: 16px 20px; margin-bottom: 0; }
.vehiculos-page .vehiculos-card .ant-card-body { padding: 16px; }
.vehiculos-page .vehiculos-form .ant-form-item { margin-bottom: 12px; padding-bottom: 0; }
.vehiculos-page .vehiculos-form .ant-form-item-label { padding: 0 0 4px; line-height: 20px; }
.vehiculos-page .vehiculos-form .ant-form-item-label > label { color: #334155; font-size: 14px; font-weight: 600; }
.vehiculos-page .vehiculos-form .ant-form-item-control { line-height: normal; }
.vehiculos-page .ant-input,
.vehiculos-detalle .ant-input,
.vehiculos-page .ant-select-selection {
    height: 40px; min-height: 40px; border: 1px solid #d8e0dc; border-radius: 8px;
    color: #334155; font-size: 14px; font-weight: 400; box-shadow: none;
}
.vehiculos-page .ant-select { width: 100%; }
.vehiculos-page .ant-select-selection__rendered { line-height: 38px; }
.vehiculos-page .ant-input::placeholder,
.vehiculos-detalle .ant-input::placeholder,
.vehiculos-page .ant-select-selection__placeholder { color: #94a3b8; font-weight: 400; }
.vehiculos-page .ant-input:hover,
.vehiculos-detalle .ant-input:hover,
.vehiculos-page .ant-select-selection:hover { border-color: #198754; }
.vehiculos-page .ant-input:focus,
.vehiculos-detalle .ant-input:focus,
.vehiculos-page .ant-select-focused .ant-select-selection {
    border-color: #198754; box-shadow: 0 0 0 3px rgba(25,135,84,0.12); outline: none;
}
.vehiculos-page .ant-btn,
.vehiculos-detalle .ant-btn { height: 40px; padding: 0 16px; border-radius: 8px; font-weight: 600; box-shadow: none; }
.vehiculos-page .ant-btn-primary:not([disabled]),
.vehiculos-detalle .ant-btn-primary:not([disabled]) { background: #198754; border-color: #198754; color: white; }
.vehiculos-page .ant-btn-primary:not([disabled]):hover,
.vehiculos-detalle .ant-btn-primary:not([disabled]):hover { background: #146c43; border-color: #146c43; }
.vehiculos-page .ant-btn:not(.ant-btn-primary):not([disabled]):hover { color: #198754; border-color: #198754; }
.vehiculos-page .ant-btn:focus-visible,
.vehiculos-detalle .ant-btn:focus-visible { outline: 3px solid rgba(25,135,84,0.35); outline-offset: 2px; }
.vehiculos-page .ant-btn-sm,
.vehiculos-detalle .ant-btn-sm { height: 32px; padding: 0 12px; font-size: 13px; }
.vehiculos-herramientas {
    display: flex; align-items: center; gap: 12px; margin-bottom: 16px; padding: 12px;
    background: #f8faf9; border: 1px solid #e1e8e4; border-radius: 12px;
}
.vehiculos-herramientas .ant-input-search { max-width: 400px; }
.vehiculos-acciones { display: flex; flex-wrap: wrap; gap: 8px; }
.vehiculos-page .vehiculos-aviso { margin: 10px 0 0; color: #64748b; font-size: 14px; }
.vehiculos-page .ant-table,
.vehiculos-detalle .ant-table { color: #334155; font-size: 14px; }
.vehiculos-page .ant-table-content,
.vehiculos-detalle .ant-table-content { border: 1px solid #e1e8e4; border-radius: 12px; overflow: hidden; }
.vehiculos-page .ant-table-thead > tr > th,
.vehiculos-detalle .ant-table-thead > tr > th { background: #eef6f1; color: #166534; font-weight: 700; white-space: nowrap; }
.vehiculos-page .ant-table-thead > tr > th,
.vehiculos-page .ant-table-tbody > tr > td,
.vehiculos-detalle .ant-table-thead > tr > th,
.vehiculos-detalle .ant-table-tbody > tr > td { padding: 12px 14px; border-bottom: 1px solid #e1e8e4; }
.vehiculos-page .ant-table-tbody > tr:nth-child(even),
.vehiculos-detalle .ant-table-tbody > tr:nth-child(even) { background: #f8faf9; }
.vehiculos-page .ant-table-tbody > tr:hover > td,
.vehiculos-detalle .ant-table-tbody > tr:hover > td { background: #f0f7f3; }
.vehiculos-detalle .ant-modal-content { border-radius: 12px; overflow: hidden; }
.vehiculos-detalle .ant-modal-header { background: #f8faf9; border-bottom: 1px solid #e1e8e4; }
.vehiculos-detalle .ant-modal-title { color: #198754; font-weight: 700; }
@media (max-width: 575px) {
    .vehiculos-herramientas { align-items: stretch; flex-direction: column; }
    .vehiculos-herramientas .ant-input-search { max-width: none; }
    .vehiculos-page .personal-cabecera { padding: 12px; }
}
</style>
